// extracted by mini-css-extract-plugin
export default {"WeArCom":"weAreCompany_WeArCom__Fh9kL","left_c":"weAreCompany_left_c__GDpma","fadein":"weAreCompany_fadein__7iRMP","visible":"weAreCompany_visible__rxp-B"};